export default "__VITE_ASSET__BmKFgryv__"